import http from '@/uteis/http'
import { criarTramitacao } from '@/uteis/action/tramite'
import { criarDevolucao } from '@/uteis/action/devolver'

export default class TramiteService {
  async tramitar (numeroProcesso, descricaoMotivo, dadosSessao, destinatario) {
    var tramite = criarTramitacao(numeroProcesso, descricaoMotivo, dadosSessao, destinatario)
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/tramitados', { ...tramite }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/tramitados', { ...tramite }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async devolver (processo, descricaoMotivo, dadosSessao, destinatario) {
    var devolucao = criarDevolucao(processo, descricaoMotivo, dadosSessao, destinatario)
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/tramitados', { ...devolucao }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/tramitados', { ...devolucao }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
